import { render, staticRenderFns } from "./DriverCabInsert.vue?vue&type=template&id=6bb7e8fd&scoped=true&"
import script from "./DriverCabInsert.vue?vue&type=script&lang=js&"
export * from "./DriverCabInsert.vue?vue&type=script&lang=js&"
import style0 from "./DriverCabInsert.vue?vue&type=style&index=0&id=6bb7e8fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7e8fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VDialog,VTextField})
